export const STATUS = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    LOADING: "LOADING",
    IN_PROGRESS: "IN_PROGRESS",
}